module.exports = __webpack_public_path__ + "img/Service_worker_caching_strategies.f89092f6.jpeg";